import { useEffect, useRef } from 'react';
import { listenTrips } from '../../channels/tripsChannel';
import { useTripsStore } from '../../stores/useTripsStore';
import { notifyTripsInitialized } from '../../channels/monitorChannel';

export function useTripsChannel() {

    const firstSync = useRef(true);

    useEffect(() => {

        const unsubscribe = listenTrips(({ tipo, payload }) => {

            const {
                setTrips,
                upsertTrip,
                removeTrip,
            } = useTripsStore.getState();

            if (tipo === 'trips-sync') {

                setTrips(payload, false);
                
                if (firstSync.current) {
                    firstSync.current = false;
                    notifyTripsInitialized();
                }

            }

            if (tipo === 'trip-upsert') {

                upsertTrip(payload, false);

            }

            if (tipo === 'trip-remove') {

                removeTrip(payload, false);

            }

        });

        return unsubscribe;

    }, []);

}